module.exports = __webpack_public_path__ + "img/ph-image.f64439fc.svg";